<template>
  <div class="authentication-wrapper">
      <Box :dynamicAttrs="{class:'radio-type-project'}">
        <h4>Type</h4>
        <RadioGroup v-model="innerProject.Auth.type">
          <a-radio value="none">
            None
          </a-radio>
          <a-radio value="basic">
            Basic
          </a-radio>
          <a-radio value="token">
            Bearer (Token)
          </a-radio>
        </RadioGroup>
        <Button :onClick="onClickUpdateForm" :dynamicAttrs="dynamicAttrsButton">Update</Button>
      </Box>
      <form class="custom-form" v-if="innerProject">
        <template v-if="innerProject.Auth.type === 'none'">
          <h4 class="form-heading">None - No Authentication required</h4>
          <p class="form-description">Your APIs are public and can access by anyone with the URL</p>
        </template>
        <template v-if="innerProject.Auth.type === 'basic'">
          <h4 class="form-heading">Basic Authentication</h4>
          <p class="form-description">Use HTTP Basic Auth Protocal to authenticate your API with a username and a password.</p>
          <div class="w-320">
            <div class="mb-3">
              <label for="authentication-project-username" class="col-form-label">Username:</label>
              <input type="text" name="project-id" v-model="innerProject.Auth.username"
              class="form-control" id="authentication-project-username">
            </div>
            <div class="mb-3">
              <label for="authentication-project-password" class="col-form-label">Password:</label>
              <input type="text" name="authentication-project-password" v-model="innerProject.Auth.password" class="form-control"
              id="authentication-project-password">
            </div>
          </div>
        </template>
        <template v-if="innerProject.Auth.type === 'token'">
            <h4 class="form-heading">Bearer Token Authentication</h4>
            <p class="form-description">You will need a Bearer Token in your request header to access your API</p>
            <div class="mb-3">
              <label for="authentication-project-token" class="col-form-label">Token:</label>
              <input type="text" name="project-token" v-model="innerProject.Auth.token"
              class="form-control" id="authentication-project-token" placeholder="a-very-secret-token">
            </div>
            <table class="tbl-token">
              <thead>
                <tr>
                  <th>Header Name</th>
                  <th>Header Value</th>
                </tr>
              </thead>
              <tr>
                <td>Authorization</td>
                <td>Bearer {{innerProject.Auth.token}}</td>
              </tr>
            </table>
        </template>
      </form>
  </div>
</template>

<script type="ts">
import { defineComponent } from 'vue';
import Button from '@/components/Button/template.vue';
import Box from '@/components/Box/template.vue';
import RadioGroup from '@/components/RadioGroup/template.vue';
import { message } from 'ant-design-vue';
import Project from '../../../models/Project';
import { projectsMapper } from '../../../store';
import './styles.scss';

export default defineComponent({
  name: 'ProjectDetails',
  components: {
    Button,
    Box,
    RadioGroup,
  },
  props: {
    project: {
      type: Project,
      default: {},
    },
  },
  data() {
    return {
      dynamicAttrsButton: {
        loading: false,
      },
      innerProject: { ...this.project },
    };
  },
  methods: {
    ...projectsMapper.mapActions(['update']),
    async onClickUpdateForm() {
      this.dynamicAttrsButton.loading = true;
      const { data } = await this.update({
        slug: this.$route.params.slug,
        project: this.innerProject,
      });
      if (data) {
        message.success('Update project successfully');
      }
      this.dynamicAttrsButton.loading = false;
    },
    onChangeType(e) {
      this.type = e.target.value;
    },
  },
});
</script>
